import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public set(key: string, value: string): Promise<string | boolean> {
    return new Promise((resolve) => {
      localStorage.setItem(key, value);
      resolve(true);
    });
  }

  public get(key: string): Promise<string | undefined> {
    return new Promise((resolve) => {
      const value: string | null = localStorage.getItem(key);

      if (value === null) resolve(undefined);
      else resolve(value);
    });
  }

  public remove(key: string): Promise<string | boolean> {
    return new Promise((resolve) => {
      localStorage.removeItem(key);
      resolve(true);
    });
  }

  public clear(): Promise<string | boolean> {
    return new Promise((resolve) => {
      localStorage.clear();
      resolve(true);
    });
  }
}
